import React from "react";
import Layout from "../Layout/Layout";
import Category from "../../components/Ecom/Category";

function CategoryFlow() {
  return (
    <Layout child="Ecom">
      <Category />
    </Layout>
  );
}

export default CategoryFlow;
